(() => {
  const script = document.querySelector('script[data-preorder-ship-date-message]');
  if (!script) return;

  const selector = '#pd-dispatch-date, [data-preorder-release-id]';
  const releaseInputSelector = 'input[name="properties[__releaseId]"]';
  // PurpleDot's shipping range ends at midnight in DÔEN's Pacific timezone.
  const dateFormat = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'America/Los_Angeles'
  });
  let waitlists;
  let scheduled = false;

  function getWaitlists() {
    if (!window.PurpleDot?.fetchWaitlists) return null;
    if (!waitlists) {
      waitlists = Promise.resolve().then(() => window.PurpleDot.fetchWaitlists()).catch(() => {
        waitlists = null;
        return [];
      });
    }
    return waitlists;
  }

  async function updateDates() {
    scheduled = false;
    if (!document.querySelector(selector)) return;
    const request = getWaitlists();
    if (!request) return;
    const releases = await request;
    if (!Array.isArray(releases)) return;

    document.querySelectorAll(selector).forEach((element) => {
      const releaseId = element.dataset.preorderReleaseId ||
        element.closest('form')?.querySelector(releaseInputSelector)?.value;
      let release = releases.find((item) => item.id === releaseId);
      if (!releaseId && element.id === 'pd-dispatch-date') {
        const productReleases = releases.filter((item) =>
          String(item.product?.id) === script.dataset.preorderProductId
        );
        if (productReleases.length === 1) release = productReleases[0];
      }
      const latest = release?.shipping_dates?.latest;
      if (!latest) return;
      const date = new Date(latest);
      if (Number.isNaN(date.getTime())) return;

      const message = script.dataset.preorderShipDateMessage.replace('[date]', dateFormat.format(date));
      if (element.textContent !== message) element.textContent = message;
    });
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateDates);
  }

  const observedSelector = `${selector}, ${releaseInputSelector}`;
  const observer = new MutationObserver((mutations) => {
    const relevant = mutations.some((mutation) => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE
        ? mutation.target : mutation.target.parentElement;
      if (target?.closest(observedSelector)) return true;
      return Array.from(mutation.addedNodes).some((node) =>
        node.nodeType === Node.ELEMENT_NODE &&
        (node.matches(observedSelector) || node.querySelector(observedSelector))
      );
    });
    if (relevant) scheduleUpdate();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['value', 'data-preorder-release-id']
  });
  document.addEventListener('load', (event) => {
    if (event.target.tagName === 'SCRIPT') scheduleUpdate();
  }, true);
  window.addEventListener('load', scheduleUpdate, { once: true });
  scheduleUpdate();
})();
